import React from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import posthog from 'posthog-js';
import { LanderShell } from './components/LanderShell';
import { AnswersProvider, useAnswers, Answers } from './context/AnswersContext';
// Quiz pages
import { Capacity } from './pages/Capacity';
import { Revenue } from './pages/Revenue';
import { Database } from './pages/Database';
import { Providers } from './pages/Providers';
import { AdSpend } from './pages/AdSpend';
import { LeadSource } from './pages/LeadSource';
import { AdSpendComfort } from './pages/AdSpendComfort';
import { Filming } from './pages/Filming';
// Standalone pages (no shell)
import { Qualified } from './pages/Qualified';
import { Thanks } from './pages/Thanks';
const FUNNEL_ROUTES = ['/', '/revenue', '/database', '/providers', '/adspend', '/lead-source', '/ad-spend-comfort', '/filming'];
const STEP_NUMBERS: Record<keyof Answers, number> = {
  capacity: 1,
  revenue: 2,
  database: 3,
  providers: 4,
  adspend: 5,
  leadsource: 6,
  comfort: 7,
  filming: 8
};
function FunnelLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    setAnswer
  } = useAnswers();
  const handleAnswer = (key: keyof Answers, nextRoute: string) => (answer: string, isDq: boolean) => {
    setAnswer(key, answer);
    posthog.capture('quiz_answer_selected', {
      question_id: key,
      answer_value: answer,
      step_number: STEP_NUMBERS[key]
    });
    if (isDq) {
      posthog.capture('dq_triggered', {
        failed_question: key,
        failed_answer: answer
      });
      window.location.href = 'https://www.med-masters.com/dq-505190';
      return;
    }
    navigate(nextRoute);
  };
  return <>
      <LanderShell data-id="element-0">
        <AnimatePresence mode="wait" data-id="element-1">
          <Routes location={location} key={location.pathname} data-id="element-2">
            <Route path="/" element={<Capacity onAnswer={handleAnswer('capacity', '/revenue')} data-id="element-4" />} data-id="element-3" />
            <Route path="/revenue" element={<Revenue onAnswer={handleAnswer('revenue', '/database')} data-id="element-6" />} data-id="element-5" />
            <Route path="/database" element={<Database onAnswer={handleAnswer('database', '/providers')} data-id="element-8" />} data-id="element-7" />
            <Route path="/providers" element={<Providers onAnswer={handleAnswer('providers', '/adspend')} data-id="element-10" />} data-id="element-9" />
            <Route path="/adspend" element={<AdSpend onAnswer={handleAnswer('adspend', '/lead-source')} data-id="element-12" />} data-id="element-11" />
            <Route path="/lead-source" element={<LeadSource onAnswer={handleAnswer('leadsource', '/ad-spend-comfort')} data-id="element-14" />} data-id="element-13" />
            <Route path="/ad-spend-comfort" element={<AdSpendComfort onAnswer={handleAnswer('comfort', '/filming')} data-id="element-16" />} data-id="element-15" />
            <Route path="/filming" element={<Filming onAnswer={handleAnswer('filming', '/qualified')} data-id="element-18" />} data-id="element-17" />
          </Routes>
        </AnimatePresence>
      </LanderShell>
    </>;
}
export function App() {
  return <AnswersProvider data-id="element-19">
      <Routes data-id="element-20">
        <Route path="/qualified" element={<Qualified data-id="element-22" />} data-id="element-21" />
        <Route path="/thanks" element={<Thanks data-id="element-24" />} data-id="element-23" />
        <Route path="*" element={<FunnelLayout data-id="element-26" />} data-id="element-25" />
      </Routes>
    </AnswersProvider>;
}